// import decryptData from "@/utils/removeEncryption";
import store from "../store"


export default {
  data: () => ({
    //armazena as permissoes do usuario
    permissionsUser: [],
  }),

  computed:{
    authUser(){
      // console.log(store.state.authUser);
      return store.state.authUser
    },
    userPermissions(){
      // console.log(this.authUser);
      if(this.authUser && this.authUser.abilities?.length){
        return this.authUser.abilities
        .map((pa) => pa);
          
      }
      return [];
    },

  },

  watch:{
    userPermissions: {
      handler(newPermissions) {
        this.permissionsUser = newPermissions;
        // console.log(this.permissionsUser);
        
      },
      immediate: true
    }
  },
  

  // mounted() {
  //   this.getProfileUser();
  //   console.log(store.state.authUser);
    
  // },

  methods: {
    // getProfileUser() {
    //   const user = store.state.authUser;
    //   console.log(store.state.authUser);
    //   // const userData = decryptData("userData", "@qG56W5w04YI");
      
    //   // AQUI PEGA DO VUEX
    //   if (user?.profile_abilities.length) {
    //     this.permissionsUser = user.profile_abilities
    //     .map(
    //       (pa) => pa.abilities.slug
    //     );
    //   }
    //   console.log(this.permissionsUser);
    // },

    validationPermission(abilitieNeed) {
      // console.log(abilitieNeed)
      return this.permissionsUser.includes(abilitieNeed);
    },
  },
};
